<template>
  <div>
    <div class="input-group">
      <input
        type="text"
        class="form-control"
        v-model="link"
        style="disabled{background-color:white}"
        id="copy-input"
        disabled
      />
      <span class="input-group-btn">
        <b-button
          style="  border-radius: 0; box-shadow: none;height:100%"
          variant="light"
          type="button"
          id="copy-button"
          data-toggle="tooltip"
          data-placement="button"
          title="Copy to Clipboard"
          @click="copy"
        >
          Copy
        </b-button>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: { link: null },
  methods: {
    copy() {
      var text = this.link;

      navigator.clipboard.writeText(text).then(
        () => {
          this.$emitter.emit("success", { message: "Copied to clipboard" });
        },
        (err) => {
          this.$emitter.emit(
            "no-success",
            "Unable to copy to clipboard " + err.message
          );
        }
      );
    },
  },
};
</script>

<style scoped>
.linkContainer {
  padding: 10px;
  font-size: larger;
  background-color: White;
  border: solid 1px gray;
}
.link {
  padding-left: 5px;
  padding-right: 5px;
}
.copy {
  border-left: 1px solid gray;
  padding-left: 10px;
  padding-right: 5px;
}
</style>
